import { SharedActions } from '@common/store/SharedProvider';
import {
  deleteRobotMissionById,
  postNewRobotMission,
  patchRobotMission,
  getGlobalMissions,
  deleteRobotScheduleById,
  postNewRobotSchedule,
  deleteCleaningZoneById,
  deleteRedZoneById,
  deleteRuleZoneById,
  postNewCleaningZone,
  postNewRedZone,
  postNewRuleZone,
  postNewLandmark,
  patchCleaningZone,
  patchRedZone,
  patchRuleZone,
  patchLandmark,
  deleteLandmarkById,
  deleteGateById,
  patchLimitZone,
  patchFloor,
  undoRedoLastAction,
  patchRoomById,
  upsertWaypointSet,
  patchRobotSchedule,
  patchEnableAllSchedules,
  patchDisableAllSchedules,
  patchGateById,
} from 'store/local-robot/local-robot-actions';
import {
  getParamList,
  patchParamList,
  getEnvironmentPollution,
  patchCustomEnvironmentPollution,
  patchNavLocalPlanner,
  patchNavTasks,
  getNavLocalPlanner,
  getNavTasks,
  getExcludedDates,
  postExcludedDate,
  patchExcludedDateById,
  deleteExcludedDateById,
  getButtonConfiguration,
  getRobotApiConfigs,
} from 'store/local-robot-configuration/local-robot-configuration-actions';
import { sendRobotWebsocketMessage } from 'store/middleware/robot-websocket-middleware';
import {
  updateCustomEnvironmentPollutionConfiguration,
  patchNavLocalPlannerRestSet,
  patchNavTasksRestSet,
  patchParamListRestSet,
  patchExcludedDatesRestSet,
  patchEnvironmentPollutionRestSet,
  toggleWaypointsEnabledAutomatically,
} from 'store/local-robot-configuration/local-robot-configuration-slice';
import {
  setSelectedRoomId,
  toggleAllGatesHidden,
  toggleAllLandmarksHidden,
  toggleAllZonesHidden,
  toggleGateIdHidden,
  toggleLandmarkIdHidden,
  toggleZoneIdHidden,
  toggleWayPointVisibility,
  setZonePlannerMouseState,
  setZonePlannerMode,
  setSelectedLandmark,
  setSelectedZone,
  sendZoneToBack,
  patchStationDrag,
  updateSelectedZonePointCoordinates,
  addSelectedZonePoint,
  updateHistory,
  setSelectedGatePoint,
  setSelectedGate,
  updateSelectedZoneCoordinatesOnDrag,
  setSelectedZoneSelectedPoint,
  setRoomLimitZoneSelectedPointId,
  setSelectedWayPoint,
  addRoomLimitZonePoint,
  addTeachAndRepeatPathPoint,
  setSelectedTeachAndRepeatZonePathPoint,
  updateRoomLimitZoneCoordinatesOnDrag,
  updateRoomLimitZonePointCoordinates,
  addLandmark,
  addWayPoint,
  updateWayPointMousePosition,
  setSelectedScheduleEntry,
  addNewDraftScheduleEntry,
  deleteDraftScheduleEntry,
  updateDraftScheduleEntry,
  patchMissionsRestSet,
  patchSchedulesRestSet,
  patchCleaningZonesRestSet,
  patchGatesRestSet,
  patchFloorsRestSet,
  patchLandmarksRestSet,
  patchLimitZonesRestSet,
  patchRedZonesRestSet,
  patchRuleZonesRestSet,
  patchWaypointsRestSet,
  patchRoomsRestSet,
  dragLandmark,
  dragWayPoint,
  copyZoneById,
  addUndoableAction,
  resetGeneratingTeachPathMessage,
  setIsGeneratingTeachPath,
  updateSelectedTeachAndRepeatPathPointCoordinates,
  patchSelectedGate,
} from 'store/local-robot/local-robot-slice';

const defaultThunkHandler = () => {
  throw new Error('Function not implemented.');
};

const SharedActionsMapper: SharedActions = {
  deleteMissionById: deleteRobotMissionById,
  postNewMission: postNewRobotMission,
  patchMission: patchRobotMission,
  getGlobalMissions,
  deleteScheduleEntryById: deleteRobotScheduleById,
  postNewScheduleEntry: postNewRobotSchedule,
  patchScheduleEntry: patchRobotSchedule,
  patchEnableAllSchedules: patchEnableAllSchedules,
  patchDisableAllSchedules: patchDisableAllSchedules,
  setSelectedRoomId: setSelectedRoomId,
  toggleAllGatesHidden: toggleAllGatesHidden,
  toggleAllLandmarksHidden: toggleAllLandmarksHidden,
  toggleAllZonesHidden: toggleAllZonesHidden,
  toggleGateIdHidden: toggleGateIdHidden,
  toggleLandmarkIdHidden: toggleLandmarkIdHidden,
  toggleZoneIdHidden: toggleZoneIdHidden,
  toggleWayPointVisibility: toggleWayPointVisibility,
  setZonePlannerMode: setZonePlannerMode,
  setZonePlannerMouseState: setZonePlannerMouseState,
  setSelectedLandmark: setSelectedLandmark,
  setSelectedZone: setSelectedZone,
  sendZoneToBack: sendZoneToBack,
  patchStationDrag: patchStationDrag,
  updateSelectedZonePointCoordinates: updateSelectedZonePointCoordinates,
  addSelectedZonePoint: addSelectedZonePoint,
  patchEnvironmentPollutionRestSet: patchEnvironmentPollutionRestSet,
  setSelectedGatePoint: setSelectedGatePoint,
  setSelectedGate: setSelectedGate,
  updateSelectedZoneCoordinatesOnDrag: updateSelectedZoneCoordinatesOnDrag,
  setSelectedZoneSelectedPoint: setSelectedZoneSelectedPoint,
  setRoomLimitZoneSelectedPointId: setRoomLimitZoneSelectedPointId,
  setSelectedWayPoint: setSelectedWayPoint,
  addRoomLimitZonePoint: addRoomLimitZonePoint,
  addTeachAndRepeatPathPoint: addTeachAndRepeatPathPoint,
  setSelectedTeachAndRepeatZonePathPoint: setSelectedTeachAndRepeatZonePathPoint,
  updateRoomLimitZoneCoordinatesOnDrag: updateRoomLimitZoneCoordinatesOnDrag,
  updateRoomLimitZonePointCoordinates: updateRoomLimitZonePointCoordinates,
  addLandmark: addLandmark,
  addWayPoint: addWayPoint,
  updateWayPointMousePosition: updateWayPointMousePosition,
  setSelectedScheduleEntry: setSelectedScheduleEntry,
  addNewDraftScheduleEntry: addNewDraftScheduleEntry,
  deleteDraftScheduleEntry: deleteDraftScheduleEntry,
  updateDraftScheduleEntry: updateDraftScheduleEntry,
  deleteCleaningZoneById: deleteCleaningZoneById,
  deleteRedZoneById: deleteRedZoneById,
  deleteRuleZoneById,
  deleteLandmarkById: deleteLandmarkById,
  postNewCleaningZone: postNewCleaningZone,
  postNewRedZone: postNewRedZone,
  postNewRuleZone,
  postNewLandmark: postNewLandmark,
  patchCleaningZone: patchCleaningZone,
  patchRedZone: patchRedZone,
  patchRuleZone,
  patchLandmark: patchLandmark,
  patchLimitZone: patchLimitZone,
  patchMissionsRestSet: patchMissionsRestSet,
  patchSchedulesRestSet: patchSchedulesRestSet,
  patchCleaningZonesRestSet: patchCleaningZonesRestSet,
  patchGatesRestSet: patchGatesRestSet,
  patchLandmarksRestSet: patchLandmarksRestSet,
  patchLimitZonesRestSet: patchLimitZonesRestSet,
  patchRedZonesRestSet: patchRedZonesRestSet,
  patchRuleZonesRestSet,
  patchWaypointsRestSet: patchWaypointsRestSet,
  dragLandmark: dragLandmark,
  deleteGateById: deleteGateById,
  upsertWaypointSet: upsertWaypointSet,
  dragWayPoint: dragWayPoint,
  getParamList: getParamList,
  patchParamList: patchParamList,
  copyZoneById: copyZoneById,
  undoRedoLastAction: undoRedoLastAction,
  addUndoableAction: addUndoableAction,
  getEnvironmentPollution: getEnvironmentPollution,
  patchCustomEnvironmentPollution: patchCustomEnvironmentPollution,
  updateCustomEnvironmentPollutionConfiguration: updateCustomEnvironmentPollutionConfiguration,
  patchFloor: patchFloor,
  patchFloorsRestSet: patchFloorsRestSet,
  patchNavLocalPlanner: patchNavLocalPlanner,
  patchNavTasks: patchNavTasks,
  patchParamListRestSet: patchParamListRestSet,
  patchNavLocalPlannerRestSet: patchNavLocalPlannerRestSet,
  patchNavTasksRestSet: patchNavTasksRestSet,
  getNavLocalPlanner: getNavLocalPlanner,
  getNavTasks: getNavTasks,
  getExcludedDates: getExcludedDates,
  postExcludedDate: postExcludedDate,
  patchExcludedDateById: patchExcludedDateById,
  deleteExcludedDateById: deleteExcludedDateById,
  patchExcludedDatesRestSet: patchExcludedDatesRestSet,
  patchRoomById: patchRoomById,
  patchRoomsRestSet: patchRoomsRestSet,
  getButtonConfiguration: getButtonConfiguration,
  sendRobotWebsocketMessage: sendRobotWebsocketMessage,
  resetGeneratingTeachPathMessage: resetGeneratingTeachPathMessage,
  setIsGeneratingTeachPath: setIsGeneratingTeachPath,
  updateSelectedTeachAndRepeatPathPointCoordinates:
    updateSelectedTeachAndRepeatPathPointCoordinates,
  toggleWaypointsEnabledAutomatically: toggleWaypointsEnabledAutomatically,
  createNewGate: defaultThunkHandler,
  getRobotApiConfigs: getRobotApiConfigs,
  patchGateById: patchGateById,
  patchSelectedGate: patchSelectedGate,
  postNewGate: defaultThunkHandler,
  setPreviousRoomLimitZone: defaultThunkHandler,
  // webapp only functions
  putEditedMapByRoomId: defaultThunkHandler,
  resetMapEditStatusState: defaultThunkHandler,
  setEditMapUpdateAction: defaultThunkHandler,
  setMapDrawColor: defaultThunkHandler,
  deleteRoomById: defaultThunkHandler,
  postRestoreRoomById: defaultThunkHandler,
  archiveMapByRoomId: defaultThunkHandler,
  putMapByRoomId: defaultThunkHandler,
  resetCroppedComponents: defaultThunkHandler,
  resetMapPutStatus: defaultThunkHandler,
  setMapCrop: defaultThunkHandler,
  putRelayGateApiConfigs: defaultThunkHandler,
  getRelayGateApiConfigs: defaultThunkHandler,
  resetRelayGateConfigPutStatus: defaultThunkHandler,
};

export default SharedActionsMapper;
